import type { FC, HTMLAttributes } from "react";

import * as styles from "./Loader.styles";

interface Props extends HTMLAttributes<HTMLDivElement> {
  text?: string;
  loading: boolean;
}

const Loader: FC<Props> = ({ text = "Loading", loading, ...rest }) => {
  if (!loading) return null;

  return (
    <div css={styles.loader} {...rest}>
      <span>
        <i className="fa fa-circle-o-notch fa-spin" /> {text}
      </span>
    </div>
  );
};

export { Loader };
